import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, ReplaySubject, takeUntil } from 'rxjs';

import { Loggable } from 'app/utils/logging/loggable';
import {
  IncomingMessage,
  IncomingMessageType,
  OutgoingMessageType,
  SearchMessage,
  BaseUser,
} from 'messages/websocket.messages';

import { socialAppSelectors } from '../../state/app';
import { WebsocketService } from '../websocket.service';

@Injectable({
  providedIn: 'root',
})
export class SearchParticipantsService extends Loggable {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  public isSearchParticipantOpen = false;
  private participantsStreamSource = new BehaviorSubject<BaseUser[]>([]);
  public participantsStreams$ = this.participantsStreamSource.asObservable();

  public constructor(
    private store: Store,
    private websocketService: WebsocketService,
  ) {
    super();
    this.setDisplayName('SearchParticipantService');

    this.websocketService.message$.pipe(takeUntil(this.destroyed$)).subscribe(this.handleWebsocketMessage);

    this.store
      .select(socialAppSelectors.isSearchOpen)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((isSearchParticipantOpen) => {
        this.toggleSearchParticipant(isSearchParticipantOpen);
      });
  }

  public toggleSearchParticipant(isSearchParticipantOpen: boolean): void {
    this.isSearchParticipantOpen = isSearchParticipantOpen;
  }

  private handleWebsocketMessage = (msg: IncomingMessage): void => {
    const { t: type } = msg;
    switch (type) {
      case IncomingMessageType.SEARCH_RESULT: {
        if (msg.results) {
          this.participantsStreamSource.next(msg.results);
        }
        return;
      }
    }
  };

  // Request to search participants
  public getParticipants(
    value: string,
    maxCount: number,
    afterUserId?: string,
    onlyPresent?: boolean,
    onlyFavorites?: boolean,
  ) {
    try {
      const msg: SearchMessage = {
        t: OutgoingMessageType.SEARCH,
        value,
        afterUserId,
        maxCount,
        onlyPresent,
        onlyFavorites,
      };
      this.websocketService.sendMessage(msg);
    } catch (e) {
      this.error('Failed to search participants data', e);
    }
  }
}
